import { render, staticRenderFns } from "./project-listing-sidebar.html?vue&type=template&id=50459cb6&"
import script from "./project-listing-sidebar.js?vue&type=script&lang=js&"
export * from "./project-listing-sidebar.js?vue&type=script&lang=js&"
import style0 from "./project-listing-sidebar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports